import util from '@bmp-vue/core/api/util'

const controller = 'Impressao'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  Get: function (dto) {
    return util.Axios.GetBlob(controller, dto)
  },
  GetAll: function (dto) {
    return util.Axios.GetAll(controller + '/GetAllComprovantes', dto)
  }
})
